import { render, staticRenderFns } from "./TaxApplicationManagement.vue?vue&type=template&id=99100eca&scoped=true"
import script from "./TaxApplicationManagement.vue?vue&type=script&lang=js"
export * from "./TaxApplicationManagement.vue?vue&type=script&lang=js"
import style0 from "./TaxApplicationManagement.vue?vue&type=style&index=0&id=99100eca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99100eca",
  null
  
)

export default component.exports